import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Client } from 'app/models/client.models';
import { ClientesService } from 'app/services/clientes.service';

@Component({
  selector: 'app-lista-cliente',
  templateUrl: './lista-cliente.component.html',
  styleUrls: ['./lista-cliente.component.css']
})
export class ListaClienteComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  clientes: Client[] = [];
  type;
  displayedColumns: string[] = ['numero', 'razonsocial','type','cuit'];
  dataSource: MatTableDataSource<Client> = new MatTableDataSource();
  loading: boolean;
  paginaSiguiente = 1;
  totalArticulos = 10;
  itemXPag = 10;
  search = '';
  lastKeypress: any;

  constructor(
    private dialogRef: MatDialogRef<ListaClienteComponent>,
    private clienteService: ClientesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.type = data.type;
    console.log(this.type);
   }

  ngOnInit(): void {
    if (this.type === 'cliente') { 
      this.getClientes();
    } else {
      this.getProveedores();
    }    
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.search = filterValue.trim().toLowerCase();
    if (event.timeStamp - this.lastKeypress > 100) {
      this.paginaSiguiente = 1;
      this.getClientes();
    }
    this.lastKeypress = event.timeStamp;
  }


  getClientes() {
    this.clienteService.getClientes(this.paginaSiguiente, this.itemXPag, this.search, 'cliente').subscribe(
      (res) => {
        this.clientes = res.data;
        this.dataSource = new MatTableDataSource(this.clientes);
        this.dataSource.paginator = this.paginator;
        this.totalArticulos = res.total;
        this.loading = false;
      },
      err => {
        console.log(err)
       // this.openSnackBar(`Ocurrió un error al obtener listado clientes`, 'Información');
        this.loading = false;
      }
    );
  }

  
  page(event) {
    if (event.pageIndex == this.paginaSiguiente) {
      this.paginaSiguiente = event.pageIndex + 1;
    } else {
      this.paginaSiguiente = this.paginaSiguiente - 1;
    }   
    this.getClientes();
  }

  getProveedores() {
    this.clienteService.getClientesBytype('proveedor').subscribe(
      (data) => {
        this.clientes = data;
        this.dataSource = new MatTableDataSource(this.clientes);
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      }
    )
  }

  cerrar(cliente?: Client) {
    if (cliente) {
      this.dialogRef.close(cliente);
    } else {
      this.dialogRef.close();
    }
  }
}
